import { ReactNode, memo, useCallback } from 'react';
import clsx from 'clsx';

export interface Tab {
  value: string;
  content: ReactNode;
}

export interface Tabs {
  className?: string;
  tabs: Array<Tab>;
  value: string;
  onClickTab: (tab: Tab) => void;
}

export const Tabs = memo(({ className, value, tabs, onClickTab }: Tabs) => {
  const handleClick = useCallback(
    (tab: Tab) => {
      onClickTab(tab);
    },
    [onClickTab]
  );

  return (
    <div className={clsx('flex gap-[10px]', className)}>
      {tabs.map(tab => {
        const isActive = tab.value === value;
        return (
          <button
            key={tab.value}
            className={clsx(
              'rounded-full px-4 py-[10px] text-sm/20 font-medium',
              isActive ? 'bg-gray-850 text-white' : 'bg-transparent text-gray-350'
            )}
            onClick={() => handleClick(tab)}
          >
            {tab.content}
          </button>
        );
      })}
    </div>
  );
});
